const Helpers = (function () {
  let helperFunctions = {};

  helperFunctions.documentLocale = () => {
    let locale = document.documentElement.lang;

    if (locale === '') {
      locale = 'fr-FR';
    }

    return locale;
  };

  helperFunctions.numberToCurrency = (value, precision) => {
    let parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return '';
    }

    let parsedPrecision = parseInt(precision);

    if (isNaN(parsedPrecision)) {
      parsedPrecision = 0;
      parsedValue = Math.floor(parsedValue);
    }

    var formatter = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF',
      minimumFractionDigits: parsedPrecision,
      maximumFractionDigits: parsedPrecision,
    });
    return formatter.format(parsedValue.toFixed(parsedPrecision)).replace(".", ",");
  };

  helperFunctions.signedNumberToCurrency = (value, precision) => {
    const parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return '';
    }

    let parsedPrecision = parseInt(precision);

    if (isNaN(parsedPrecision)) {
      parsedPrecision = 2;
    }

    let formattedValue = helperFunctions.numberToCurrency(Math.abs(parsedValue), parsedPrecision);

    if (parsedValue >= 0) {
      return `+ ${formattedValue}`;
    } else {
      return `- ${formattedValue}`;
    }
  };

  helperFunctions.capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  helperFunctions.numberIsMultipleOf = (number, multiple) => {
    number = parseInt(number);
    multiple = parseInt(multiple);

    return !isNaN(number) && !isNaN(multiple) && (multiple === 0 || number % multiple === 0);
  };

  helperFunctions.closestMultiplesOf = (number, multiple) => {
    number = parseInt(number);
    multiple = parseInt(multiple);

    if (helperFunctions.numberIsMultipleOf(number, multiple)) {
      return [number, number];
    }

    let next_multiple = Math.trunc((number + multiple - 1) / multiple) * multiple;
    let previous_multiple = Math.min(next_multiple - multiple, next_multiple);

    return [previous_multiple, next_multiple];
  };

  helperFunctions.parseFloatWithFallback = (value, fallback) => {
    let parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      if (typeof fallback === 'function') {
        parsedValue = fallback(value);
      } else {
        parsedValue = fallback;
      }
    }

    return parsedValue;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  //
  // Taken from: https://davidwalsh.name/javascript-debounce-function
  helperFunctions.debounce = (func, wait, immediate) => {
    let timeout;

    return function () {
      let context = this,
        args = arguments;
      let later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  return helperFunctions;
})();

export { Helpers };
